import { TableProps } from '@aibees/shared/components';
export interface EnrichButtonProps {
  className?: string;
  disabled?: boolean;
  table?: TableProps;
  isSmall?: boolean;
}

// Saved Records → Enrich holds update actions only. First-time enrichment
// (emails, mobile numbers, profile insights) and email re-verification live on
// Total Records and the save / export / list / label panels.
export enum EnrichButtonDialogType {
  UpdateAll = 'UpdateAll',
  UpdateJobChange = 'UpdateJobChange',
  UpdateProfileInsights = 'UpdateProfileInsights',
}
